// extracted by mini-css-extract-plugin
module.exports = {"BASE":"mainTheme-module--BASE--3CsbZ"};